export enum CONDITIONS {
  GREATER = 'Greater Than',
  LESS = 'Less Than',
  EQUAL = 'Equal To',
  GREATER_OR_EQUAL = 'Greater than or equal to',
  LESS_OR_EQUAL = 'Less than or equal to',
  NO_EQUAL = 'Not Equal To',
}
